import React from "react";
import Icon from "../../../assets/Icon";
import { Link, useNavigate } from "react-router-dom";

function MockTestCard({ moduleInfo }) {
  const navigate = useNavigate();
  const handleNavigate = () => {
    if (moduleInfo?.hasMockTestAccess) {
      navigate("/test");
    } else {
      window.location.href = "https://www.hireplusplus.com/contact-us";
    }
  };
  return (
    <Link
      to="/test"
      // onClick={handleNavigate}
      className="relative driver-mock-test orange-card basis-[49%] flex flex-col gap-[0.3rem] rounded-xl shadow px-[1rem] xl:px-[1.45rem] py-[1.2rem] hover-effect cursor-pointer"
    >
      <div className="flex flex-col gap-1">
        <div className="border-[2px] py-[.45rem] px-[.5rem] border-[#DFDFDF] flex justify-center items-center w-fit rounded-[8px]">
          <Icon type="mock-test-logo" color="#101828" />
        </div>

        <div className="text-[#101828] font-semibold text-[1rem]">
          Mock Test
        </div>
      </div>
      <div className="text-[#475467] font-medium text-[0.875rem]">
        Practice with mock interviews featuring technical, behavioral, and
        situational questions.
      </div>
      <div className="lg:mt-8">
        <div className="lg:absolute block bottom-5 xl:left-6 left-4">
          {moduleInfo?.hasMockTestAccess ? (
            <span className="text-amber-600 w-fit font-semibold hover:text-amber-500 transition-all duration-200 text-[0.875rem] pt-[0.36rem] flex gap-2 items-center">
              Start Practicing Now <Icon type="right-arrow" color="#d97706" />
            </span>
          ) : (
            <span className="text-amber-600 w-fit font-semibold hover:text-amber-500 transition-all duration-200 text-[0.875rem] pt-[0.36rem] flex gap-2 items-center">
              Request Access <Icon type="right-arrow" color="#d97706" />
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}

export default MockTestCard;
